import { ChevronDown } from 'lucide-react'
import { useState } from 'react'

import { Button } from '../ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import LoadingSpin from './LoadingSpin'

export interface BtnActions {
  icon?: React.ReactNode
  loading?: boolean
  title: string
  action?: (_close: () => void) => void
  disabled?: boolean
}

interface MultiBtn {
  btnIcon?: React.ReactNode
  btnName?: string
  items: BtnActions[]
  size?: 's' | 'm'
}

export default function MultipleActBtn({ btnName, items }: MultiBtn) {
  const [open, setOpen] = useState(false)
  return (
    <div className="z-20 inline-flex flex-shrink-0 shadow-sm">
      <DropdownMenu onOpenChange={setOpen} open={open}>
        <DropdownMenuTrigger asChild>
          <Button className="gap-1" variant="outline">
            <span>{btnName ?? 'Acciones'}</span>
            <ChevronDown className="h-3.5 w-3.5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {items.map((item) => (
            <DropdownMenuItem
              className="hover:cursor-pointer"
              disabled={item.disabled}
              key={item.title}
              onClick={() => {
                if (item.action) {
                  item.action(() => setOpen(false))
                }
              }}
            >
              {item?.loading ? (
                <LoadingSpin color="slate-600" />
              ) : (
                item.icon && item.icon
              )}
              {item.title}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
